import { initI18n } from '@/utils/i18n'

// 默认语言由构建时环境变量 VUE_APP_DEFAULT_LANG 决定（国内站 zh，海外站 en）
const supportedLangs = ['en', 'zh', 'es', 'ar', 'pt', 'fr', 'de', 'ko']
const envDefaultLang = (process.env.VUE_APP_DEFAULT_LANG || 'en').toLowerCase()
const defaultLang = supportedLangs.includes(envDefaultLang) ? envDefaultLang : 'en'

const i18n = initI18n(defaultLang, 'en')

export default i18n
